import React from "react";
import { Icon, Text } from "@mbank-design/design-system/components";
import "./index.scss";
import { IconSvgComponent } from "@mbank-design/design-system/components/Icon/Icon";
import type { IconProps } from "@mbank-design/design-system/components/Icon/Icon.types";
import { FontColor } from "@mbank-design/design-system/design-tokens/general/typography";
import type { ValuesOf } from '@mbank-design/design-system/types';

interface TextStyleProps {
  color?: string;
  size?: string;
  weight?: string;
}

interface IconListProps {
    icon?: IconSvgComponent;
    iconColor?: IconProps['primaryColor'];
    textChar?: string;
    charStyle?: TextStyleProps;
    content: string | string[];
    header?: string;
    headerType?: "h1" | "h2" | "h3" | "h4" | "h5" | "p"| "body";
    textColor?: ValuesOf<typeof FontColor>;
    marginBottom?: number;
    itemWidth?: string;
}

export const IconList = ({ icon, iconColor, textChar, charStyle, content, header, textColor, headerType = "h2", marginBottom = 0, itemWidth }: IconListProps) => {
  return <div style={{ marginBottom: marginBottom }}>
    {header && <Text as={"h2"} styledAs={headerType} color={textColor}>{header}</Text>}
    <div className="icon-list-items">
      {Array.isArray(content) ? content.map((item, index) => (
        <IconListItem 
          key={index} 
          icon={icon} 
          iconColor={iconColor} 
          textChar={textChar}
          charStyle={charStyle}
          text={item} 
          textColor={textColor}
          itemWidth={itemWidth}
        />
      )) : <IconListItem 
        icon={icon} 
        iconColor={iconColor} 
        textChar={textChar}
        charStyle={charStyle}
        text={content}
        textColor={textColor}
        itemWidth={itemWidth}
      />}
    </div>
  </div>;
};

interface IconListItemProps {
  icon?: IconSvgComponent;
  iconColor?: IconProps['primaryColor'];
  textChar?: string;
  charStyle?: TextStyleProps;
  text: string;
  textColor?: string;
  itemWidth?: string;
}

const IconListItem = ({ icon, iconColor, textChar, charStyle, text, textColor, itemWidth }: IconListItemProps) => {
  const renderIconOrText = () => {
    if (icon) {
      return <Icon iconComponent={icon} primaryColor={iconColor}></Icon>;
    } else if (textChar) {
      const style = {
        color: charStyle?.color,
        fontSize: charStyle?.size,
        fontWeight: charStyle?.weight,
      };
      return <span style={style}>{textChar}</span>;
    }
    return null;
  };

  return <div className="icon-list-item" style={itemWidth ? { width: itemWidth } : undefined}>
    {renderIconOrText()}
    <Text as="body" color={textColor} dangerouslySetInnerHTML={{ __html: text }}></Text>
  </div>;
};


